import { applyMiddleware, combineReducers, configureStore} from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { composeWithDevTools } from "redux-devtools-extension";

import thunk from 'redux-thunk';
import logger from "redux-logger";
// import reducers
import AdminUserReducer from "../reducers/adminUser";
import AccountReducer from "../reducers/account";
import environmentReducer from "../reducers/environment";

const persistConfig = {
  key: "store",
  storage,
  whitelist: ['adminUser', 'account', 'environment'], // Add environment to persisted state
};

const rootReducer = combineReducers({
  adminUser: AdminUserReducer,
  account: AccountReducer,
  environment: environmentReducer,
});

const pReducer = persistReducer(persistConfig, rootReducer);
const middleware = applyMiddleware(thunk, logger);

export const store = configureStore({reducer : pReducer}, composeWithDevTools(middleware));
export const persistor = persistStore(store);
// export default store;

